import axios from 'axios';
import { PROCESS_AUTOMATION_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

export const fetchRepositories = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/azure/repositories`, {
      headers: {
        ...commonRequestHeaders(),
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching repositories:', error);
    throw error;
  }
};
